import { useEffect, useState } from "react";
import Table from "../common/table";
import getCurrentUnidadeId from "../../funcs/getCurrentUnidadeId";
import { format } from "date-fns";
import apiLeituraLinhaLiquido from "../../services/apis/Leituras/apiLeituraLinhaLiquido";

export default function LinhaLiquido() {

    const [leitura, setLeitura] = useState();
    const unidadeId = getCurrentUnidadeId();

    useEffect(() => {
        (async () => {
        const res = await apiLeituraLinhaLiquido.getUltimaLeitura(unidadeId);
            const lq = res.data;
            setLeitura(lq);
        })();
    },[unidadeId]);

    return 	<div className="w-full">
        <Table.Root>
            <Table.Head>
                <Table.Header>Data hora</Table.Header>
                <Table.Header>Temperatura</Table.Header>
                <Table.Header>Pressão Convertida</Table.Header>
            </Table.Head>
            <Table.Body>
                {
                    leitura &&
                    <Table.Row
                        key={leitura.id}
                    >
                        <Table.Data>{format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss")}</Table.Data>
                        <Table.Data>{leitura.temperatura}</Table.Data>
                        <Table.Data>{leitura.pressaoConvertida}</Table.Data>
                    </Table.Row>
                }
            </Table.Body>
        </Table.Root>
    </div>
}